module.exports = __webpack_public_path__ + "static/img/2.b0c7bb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.png
// module id = chPc
// module chunks = 1